import React from 'react'
import { makeStyles, Tooltip } from '@material-ui/core'
import { STUDIO_NETWORK_LEVEL } from '../../../hooks/useStudioRoom'
import COLORS from '../../../utils/constants/colors'

const useStyles = makeStyles({
  chip: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '8px',
    padding: '5px 10px',
    borderRadius: '16px',
    background: COLORS.backgroundGrey,
    cursor: 'default',
  },
  bars: {
    display: 'inline-flex',
    alignItems: 'flex-end',
    gap: '3px',
    height: '15px',
  },
  bar: {
    width: '4px',
    borderRadius: '1px',
    transition: 'background 0.3s ease',
  },
  b1: { height: '7px' },
  b2: { height: '11px' },
  b3: { height: '15px' },
  label: {
    fontSize: '13px',
    fontWeight: 600,
  },
})

const LEVELS = {
  [STUDIO_NETWORK_LEVEL.GOOD]: {
    filled: 3,
    color: COLORS.green,
    label: 'Good',
    tooltip: 'Your connection is good',
  },
  [STUDIO_NETWORK_LEVEL.WEAK]: {
    filled: 2,
    color: COLORS.darkerOrange,
    label: 'Weak',
    tooltip: 'Your connection is weak — preview may stutter',
  },
  [STUDIO_NETWORK_LEVEL.BAD]: {
    filled: 1,
    color: COLORS.red,
    label: 'Poor',
    tooltip: 'Your connection is poor — preview and commentary may be affected',
  },
}

// Persistent connection indicator: 3 signal bars + a status word, in a subtle chip.
// `dark` drops the chip background + lightens the empty bars for use on a dark surface
// (the theater control pill).
const NetworkBars = ({ level, dark = false }) => {
  const classes = useStyles()
  const cfg = LEVELS[level] || LEVELS[STUDIO_NETWORK_LEVEL.GOOD]
  const heights = [classes.b1, classes.b2, classes.b3]
  const emptyColor = dark ? 'rgba(255, 255, 255, 0.28)' : COLORS.borderGrey

  return (
    <Tooltip title={cfg.tooltip} arrow>
      <span
        className={classes.chip}
        aria-label={cfg.tooltip}
        style={dark ? { background: 'transparent', padding: 0 } : undefined}
      >
        <span className={classes.bars}>
          {heights.map((h, i) => (
            <span
              key={i}
              className={`${classes.bar} ${h}`}
              style={{ background: i < cfg.filled ? cfg.color : emptyColor }}
            />
          ))}
        </span>
        <span className={classes.label} style={{ color: cfg.color }}>
          {cfg.label}
        </span>
      </span>
    </Tooltip>
  )
}

export default NetworkBars
